// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ClaimDetailsResponseModel } from './claimDetailsResponseModel.js';
import type { GatewayPharmacyClaimModel } from './gatewayPharmacyClaimModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PharmacyClaimSearchResponseModel {
    'claim': GatewayPharmacyClaimModel | null;
    'claimDetails'?: ClaimDetailsResponseModel | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PharmacyClaimSearchResponseModel>> = [
        {
            "name":     "claim",
            "baseName": "claim",
            "type":     "GatewayPharmacyClaimModel"
        },
        {
            "name":     "claimDetails",
            "baseName": "claimDetails",
            "type":     "ClaimDetailsResponseModel"
        },
    ];

    static getAttributeTypeMap() {
        return PharmacyClaimSearchResponseModel.attributeTypeMap;
    }
}
